import React from 'react';
import { Hero } from './components/Hero';
import { Stats } from './components/Stats';
import { Testimonials } from './components/Testimonials';
import { PainPoints } from './components/PainPoints';
import { Tomos } from './components/Tomos';
import { Bonuses } from './components/Bonuses';
import { Countdown } from './components/Countdown';
import { Pricing } from './components/Pricing';
import { FAQ } from './components/FAQ';
import { ValueStack } from './components/ValueStack';
import { Footer } from './components/Footer';
import { MetaPixel } from './components/MetaPixel';
export function App() {
  return <div className="min-h-full w-full bg-ink text-white" data-id="element-0" data-mp="31brz38d2snk2">
      <MetaPixel data-id="element-1" data-mp="2wk06yte9u9rt" />
      <main data-id="element-2" data-mp="2wjgu3r3habkn">
        <Hero data-id="element-3" data-mp="2wiywaq163pam" />
        <Stats data-id="element-4" data-mp="2wiff5bjcd4xn" />
        <Testimonials data-id="element-5" data-mp="2wip2ssgwz006" />
        <PainPoints data-id="element-6" data-mp="28ufo0ai4bcij" />
        <Tomos data-id="element-7" data-mp="28tw3qn4zwc1c" />
        <Bonuses data-id="element-8" data-mp="28te2fc3h77mk" />
        <Countdown data-id="element-9" data-mp="28suvsrja05nu" />
        <Pricing data-id="element-10" data-mp="28sbad0uf2z52" />
        <FAQ data-id="element-11" data-mp="23vcikoy874a1" />
        <ValueStack data-id="element-12" data-mp="23vunsb2v8su3" />
      </main>
      <Footer data-id="element-13" data-mp="23ujho4ly78zt" />
    </div>;
}